/* ============================================
   THE100 SHOPIFY THEME - JAVASCRIPT
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* --- MOBILE MENU --- */
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      this.classList.toggle('is-active');
      mobileMenu.classList.toggle('is-open');
      document.body.style.overflow = mobileMenu.classList.contains('is-open') ? 'hidden' : '';
    });

    // Close on link click (but not submenu triggers)
    mobileMenu.querySelectorAll('a:not(.mobile-menu__has-submenu)').forEach(function(link) {
      link.addEventListener('click', function() {
        mobileToggle.classList.remove('is-active');
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Close button
    var mobileClose = mobileMenu.querySelector('.mobile-menu__close');
    if (mobileClose) {
      mobileClose.addEventListener('click', function() {
        mobileToggle.classList.remove('is-active');
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }

    // Mobile submenu toggle
    mobileMenu.querySelectorAll('.mobile-menu__has-submenu').forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        var submenu = this.nextElementSibling;
        if (submenu) {
          submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
        }
      });
    });
  }

  /* --- LOCALE SELECTOR --- */
  var localeToggle = document.querySelector('.header__locale-toggle');
  var localeDropdown = document.querySelector('.header__locale-dropdown');
  if (localeToggle && localeDropdown) {
    localeToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = !localeDropdown.hidden;
      localeDropdown.hidden = isOpen;
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.header__locale-selector')) {
        localeDropdown.hidden = true;
      }
    });
  }

  /* --- SEARCH TOGGLE --- */
  var searchToggle = document.querySelector('.header__search-toggle');
  var searchBar = document.querySelector('#header-search-bar');
  if (searchToggle && searchBar) {
    var searchInput = searchBar.querySelector('input[name="q"]');
    var searchResults = document.querySelector('#header-search-results');
    var searchRequestTimer;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function hideSearchResults() {
      if (!searchResults) return;
      searchResults.hidden = true;
      searchResults.innerHTML = '';
    }

    function renderSearchResults(products, query) {
      if (!searchResults) return;

      if (!products.length) {
        searchResults.innerHTML = '<div class="header__search-results-empty">No products found</div>';
        searchResults.hidden = false;
        return;
      }

      var items = products.map(function(product) {
        var imageHtml = '';
        if (product.featured_image && product.featured_image.url) {
          imageHtml = '<div class="header__search-result-image"><img src="' + product.featured_image.url + '" alt="' + escapeHtml(product.featured_image.alt || product.title) + '"></div>';
        }

        return '<a class="header__search-result" href="' + product.url + '">' + imageHtml + '<div class="header__search-result-title">' + escapeHtml(product.title) + '</div></a>';
      }).join('');

      searchResults.innerHTML = items + '<a class="header__search-results-footer" href="/search?q=' + encodeURIComponent(query) + '&type=product">View all results</a>';
      searchResults.hidden = false;
    }

    function fetchSearchResults(query) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
        .then(function(response) { return response.json(); })
        .then(function(data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products
            : [];
          renderSearchResults(products, query);
        })
        .catch(function() {
          hideSearchResults();
        });
    }

    searchToggle.addEventListener('click', function(e) {
      e.preventDefault();
      if (searchBar.classList.contains('is-open') && searchInput.value.trim()) {
        searchBar.submit();
      } else {
        searchBar.classList.toggle('is-open');
        if (searchBar.classList.contains('is-open')) {
          searchInput.focus();
        } else {
          hideSearchResults();
        }
      }
    });

    searchInput.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(searchRequestTimer);

      if (query.length < 2) {
        hideSearchResults();
        return;
      }

      searchRequestTimer = setTimeout(function() {
        fetchSearchResults(query);
      }, 180);
    });

    searchBar.addEventListener('submit', function() {
      hideSearchResults();
    });

    document.addEventListener('click', function(event) {
      if (!searchBar.contains(event.target) && !searchToggle.contains(event.target)) {
        hideSearchResults();
      }
    });
  }

  /* --- HERO SLIDESHOW: Handled autonomously in sections/hero-slideshow.liquid --- */

  /* --- ACCORDION (Product + FAQ) --- */
  function initAccordions(container) {
    var root = container || document;
    root.querySelectorAll('.product-accordion__trigger, .faq-item__question').forEach(function(trigger) {
      if (trigger.hasAttribute('data-size-guide-img') || trigger._accInit) return;
      trigger._accInit = true;
      trigger.addEventListener('click', function() {
        var parent = this.closest('.product-accordion__item, .faq-item');
        var content = parent ? parent.querySelector('.product-accordion__content, .faq-item__answer') : null;
        var isOpen = parent && (parent.classList.contains('is-open') || this.classList.contains('is-open'));

        if (isOpen) {
          if (parent) parent.classList.remove('is-open');
          this.classList.remove('is-open');
          if (content) content.classList.remove('is-open');
        } else {
          var group = parent ? parent.closest('.product-page__accordions-left, .product-page__accordions') : null;
          if (group && parent && parent.classList.contains('product-accordion__item')) {
            group.querySelectorAll('.product-accordion__item.is-open').forEach(function(sibling) {
              if (sibling !== parent) {
                sibling.classList.remove('is-open');
                var sibTrigger = sibling.querySelector('.product-accordion__trigger');
                var sibContent = sibling.querySelector('.product-accordion__content');
                if (sibTrigger) sibTrigger.classList.remove('is-open');
                if (sibContent) sibContent.classList.remove('is-open');
              }
            });
          }
          if (parent) parent.classList.add('is-open');
          this.classList.add('is-open');
          if (content) content.classList.add('is-open');
        }
      });
    });
  }
  initAccordions();

  /* Auto-open first accordion in multipack left column */
  (function () {
    var leftCol = document.querySelector('.product-page__accordions-left');
    if (!leftCol) return;
    var firstItem = leftCol.querySelector('.product-accordion__item');
    if (!firstItem) return;
    var trigger = firstItem.querySelector('.product-accordion__trigger');
    var content = firstItem.querySelector('.product-accordion__content');
    if (trigger && !trigger.hasAttribute('data-size-guide-img')) {
      if (window.innerWidth > 1024) {
        firstItem.classList.add('is-open');
        trigger.classList.add('is-open');
        if (content) content.classList.add('is-open');
      }
    }
  }());

  /* --- UNIFIED PRODUCT VARIANT & GALLERY CONTROLLER --- */
  function initProductVariants(container) {
    var root = container || document;
    var productSections = root.querySelectorAll('.product-page[data-section-id]');
    productSections.forEach(function(productSection) {
      if (productSection._variantInit) return;
      productSection._variantInit = true;

      var form = productSection.querySelector('.product-form');
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      var jsonEl = productSection.querySelector('[data-product-variants-json]');
      if (!form || !variantInput || !jsonEl) return;

      var variants = [];
      try {
        variants = JSON.parse(jsonEl.textContent || '[]');
      } catch (err) {
        return;
      }
      if (!variants.length) return;

      var currentOptions = {};
      var initialVariant = variants.find(function(v) { return String(v.id) === String(variantInput.value); }) || variants[0];
      if (initialVariant && initialVariant.options) {
        initialVariant.options.forEach(function(optVal, idx) {
          currentOptions[idx] = optVal;
        });
      }

      var atcWrapper = productSection.querySelector('[data-standard-atc-wrapper]');
      var lockMsg = productSection.querySelector('[data-restock-lock-msg]');
      var lockMsgDate = productSection.querySelector('[data-restock-date-display]');
      var buyBtns = productSection.querySelector('[data-buy-buttons-content]');
      var atcBtn = productSection.querySelector('.product-atc');
      var atcText = atcBtn ? atcBtn.querySelector('.product-atc__text') : null;
      var acceleratedCheckout = productSection.querySelector('.accelerated-checkout-block');
      var stockBadge = productSection.querySelector('[data-product-stock-badge]');
      var stockBadgeTitle = stockBadge ? stockBadge.querySelector('[data-stock-badge-title]') : null;

      var priceWrapper = productSection.querySelector('.product-price-wrapper');
      var colorLabelVal = productSection.querySelector('.product-color-label span');
      var mainImg = document.getElementById('product-main-image');
      var mobileTrack = productSection.querySelector('.product-page__mobile-track');
      var mainSlide = mobileTrack ? mobileTrack.querySelector('.product-page__mobile-slide--main') : null;
      var thumbs = productSection.querySelectorAll('[data-gallery-thumb]');
      var restockTimer = null;

      function updateImage(imageUrl) {
        if (!imageUrl) return;
        if (mainImg) mainImg.src = imageUrl;
        if (mainSlide) {
          mainSlide.dataset.slideSrc = imageUrl;
          var slideImg = mainSlide.querySelector('img');
          if (slideImg) slideImg.src = imageUrl;
          if (mobileTrack) mobileTrack.scrollTo({ left: mainSlide.offsetLeft, behavior: 'smooth' });
        }
        if (thumbs.length) {
          thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === 0); });
        }
      }

      function updateVariant() {
        if (restockTimer) {
          clearTimeout(restockTimer);
          restockTimer = null;
        }

        var matched = variants.find(function(v) {
          return v.options.every(function(val, idx) {
            return currentOptions[idx] === undefined || currentOptions[idx] === val;
          });
        });

        if (matched) {
          if (variantInput.value !== String(matched.id)) {
            variantInput.value = matched.id;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          if (priceWrapper) {
            if (matched.compare) {
              priceWrapper.innerHTML = '<p class="product-price--compare">' + matched.compare + '</p><p class="product-price product-price--sale">' + matched.price + '</p>';
            } else {
              priceWrapper.innerHTML = '<p class="product-price">' + matched.price + '</p>';
            }
          }

          if (matched.image) {
            updateImage(matched.image);
          }

          var isZeroStock = false;
          if (matched.inventory_tracked && matched.inventory_quantity <= 0) {
            isZeroStock = true;
          } else if (!matched.available) {
            isZeroStock = true;
          }

          var nowSec = Math.floor(Date.now() / 1000);
          var isRestockActive = false;
          if (matched.is_restocked && (!matched.restock_timestamp || matched.restock_timestamp > nowSec || matched.restock_timestamp === 0)) {
            isRestockActive = true;
          }

          if (isZeroStock && isRestockActive && matched.inventory_policy === 'continue') {
            // Wariant ma stan 0, jest na liście restocku i ma włączoną sprzedaż (continue) -> PREORDER
            if (lockMsg) lockMsg.style.display = 'none';
            if (buyBtns) buyBtns.style.display = '';
            if (atcBtn) {
              atcBtn.disabled = false;
              var dateStr = matched.restock_date || atcBtn.dataset.restockDate || '';
              var preorderLabel = 'Zamów w preorderze / Dostawa od ' + dateStr;
              if (atcText) atcText.textContent = preorderLabel.trim();
            }
            if (acceleratedCheckout) {
              acceleratedCheckout.hidden = false;
              acceleratedCheckout.style.display = '';
            }
            if (stockBadge) {
              stockBadge.style.display = 'none';
            }
          } else if (isZeroStock && isRestockActive && matched.inventory_policy === 'deny') {
            // Wariant ma stan 0, jest na liście restocku i ma zablokowaną sprzedaż (deny) -> BLOKADA RESTOCKU
            if (lockMsg) {
              if (lockMsgDate && matched.restock_formatted) {
                lockMsgDate.textContent = matched.restock_formatted;
              }
              lockMsg.style.display = '';
            }
            if (buyBtns) buyBtns.style.display = 'none';
            if (atcBtn) {
              atcBtn.disabled = true;
              if (atcText) atcText.textContent = atcBtn.dataset.textSoldout || 'Wyprzedane';
            }
            if (acceleratedCheckout) {
              acceleratedCheckout.hidden = true;
              acceleratedCheckout.style.display = 'none';
            }
            if (stockBadge) {
              stockBadge.style.display = '';
              stockBadge.classList.add('product-stock-badge--restock');
              if (stockBadgeTitle && matched.restock_formatted) {
                stockBadgeTitle.textContent = 'RESTOCK ' + matched.restock_formatted;
              }
            }

            // Timer odblokowania, gdy nadejdzie czas restocku
            if (matched.restock_timestamp) {
              var msUntilRestock = (matched.restock_timestamp * 1000) - Date.now();
              if (msUntilRestock > 0 && msUntilRestock <= 86400000) {
                restockTimer = setTimeout(function() {
                  updateVariant();
                }, msUntilRestock + 500);
              }
            }
          } else if (isZeroStock) {
            // Standardowy brak towaru (wyprzedane, wariant nie jest w restocku)
            if (lockMsg) lockMsg.style.display = 'none';
            if (buyBtns) buyBtns.style.display = '';
            if (atcBtn) {
              atcBtn.disabled = true;
              if (atcText) atcText.textContent = atcBtn.dataset.textSoldout || 'Wyprzedane';
            }
            if (acceleratedCheckout) {
              acceleratedCheckout.hidden = true;
              acceleratedCheckout.style.display = 'none';
            }
            if (stockBadge) {
              stockBadge.style.display = '';
              stockBadge.classList.remove('product-stock-badge--restock');
              if (stockBadgeTitle) {
                stockBadgeTitle.textContent = stockBadge.dataset.soldOutText || 'WYPRZEDANE';
              }
            }
          } else {
            // Wariant JEST na stanie -> normalny zakup
            if (lockMsg) lockMsg.style.display = 'none';
            if (buyBtns) buyBtns.style.display = '';
            if (atcBtn) {
              atcBtn.disabled = false;
              if (atcText) atcText.textContent = atcBtn.dataset.textAvailable || 'Dodaj do koszyka';
            }
            if (acceleratedCheckout) {
              acceleratedCheckout.hidden = false;
              acceleratedCheckout.style.display = '';
            }
            if (stockBadge) {
              stockBadge.style.display = 'none';
            }
          }

          try {
            var newUrl = new URL(window.location.href);
            newUrl.searchParams.set('variant', matched.id);
            window.history.replaceState({}, '', newUrl.toString());
          } catch(e) {}
        } else {
          if (atcBtn) {
            atcBtn.disabled = true;
            if (atcText) atcText.textContent = atcBtn.dataset.textSoldout || 'Niedostępny';
          }
          if (acceleratedCheckout) {
            acceleratedCheckout.hidden = true;
            acceleratedCheckout.style.display = 'none';
          }
          if (lockMsg) lockMsg.style.display = 'none';
          if (buyBtns) buyBtns.style.display = '';
          if (stockBadge) stockBadge.style.display = 'none';
        }
      }

      if (initialVariant && initialVariant.image) {
        updateImage(initialVariant.image);
      }
      updateVariant();

      // Delegated click handler on product section
      productSection.addEventListener('click', function(e) {
        // Swatch
        var swatch = e.target.closest('.product-swatch');
        if (swatch) {
          var parent = swatch.closest('.product-swatches');
          if (parent) parent.querySelectorAll('.product-swatch').forEach(function(s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');

          var colorVal = swatch.dataset.color;
          var optIdx = parseInt(swatch.dataset.optionIndex, 10);
          currentOptions[optIdx] = colorVal;
          if (colorLabelVal) colorLabelVal.textContent = colorVal;

          productSection.querySelectorAll('.product-size-btn').forEach(function(btn) {
            var btnColor = btn.dataset.variantColor;
            btn.style.display = (!btnColor || btnColor === colorVal) ? '' : 'none';
          });

          var activeSizeBtn = productSection.querySelector('.product-size-btn.is-active');
          if (activeSizeBtn && activeSizeBtn.style.display === 'none') {
            activeSizeBtn.classList.remove('is-active');
            var firstAvailableSize = productSection.querySelector('.product-size-btn:not([style*="display: none"]):not([style*="display:none"]):not(.is-disabled)');
            var firstVisibleSize = firstAvailableSize || productSection.querySelector('.product-size-btn:not([style*="display: none"]):not([style*="display:none"])');
            if (firstVisibleSize) {
              firstVisibleSize.classList.add('is-active');
              currentOptions[parseInt(firstVisibleSize.dataset.optionIndex, 10)] = firstVisibleSize.dataset.variantSize;
            }
          }
          updateVariant();
          return;
        }

        // Size button
        var sizeBtn = e.target.closest('.product-size-btn');
        if (sizeBtn) {
          var sParent = sizeBtn.closest('.product-sizes__options');
          if (sParent) sParent.querySelectorAll('.product-size-btn').forEach(function(b) { b.classList.remove('is-active'); });
          sizeBtn.classList.add('is-active');

          var sOptIdx = parseInt(sizeBtn.dataset.optionIndex, 10);
          currentOptions[sOptIdx] = sizeBtn.dataset.variantSize;
          updateVariant();
          return;
        }

        // Other option button
        var optionBtn = e.target.closest('.product-option-btn');
        if (optionBtn) {
          var oParent = optionBtn.closest('.product-option__btns');
          if (oParent) oParent.querySelectorAll('.product-option-btn').forEach(function(b) { b.classList.remove('is-active'); });
          optionBtn.classList.add('is-active');

          var oOptIdx = parseInt(optionBtn.dataset.optionIndex, 10);
          currentOptions[oOptIdx] = optionBtn.dataset.optionValue;
          var labelEl = optionBtn.closest('.product-option') ? optionBtn.closest('.product-option').querySelector('.product-option__selected') : null;
          if (labelEl) labelEl.textContent = optionBtn.dataset.optionValue;
          updateVariant();
          return;
        }
      });
    });
  }
  initProductVariants();

  /* --- PRODUCT MOBILE GALLERY --- */
  function initProductGalleries(container) {
    var root = container || document;
    root.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      if (gallery._galleryInit) return;
      gallery._galleryInit = true;

      var track = gallery.querySelector('.product-page__mobile-track');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (!track || !thumbs.length) return;

      function setActiveThumb(index) {
        thumbs.forEach(function(thumb, thumbIndex) {
          thumb.classList.toggle('is-active', thumbIndex === index);
        });
      }

      thumbs.forEach(function(thumb, index) {
        thumb.addEventListener('click', function() {
          var slide = track.children[index];
          if (!slide) return;
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
          setActiveThumb(index);
        });
      });

      var scrollRaf = null;
      track.addEventListener('scroll', function() {
        if (!scrollRaf) {
          scrollRaf = requestAnimationFrame(function() {
            var activeIndex = Math.round(track.scrollLeft / track.clientWidth);
            setActiveThumb(activeIndex);
            scrollRaf = null;
          });
        }
      }, { passive: true });
    });
  }
  initProductGalleries();

  /* --- PRODUCT CARD SWATCH DELEGATION --- */
  document.addEventListener('click', function(e) {
    var swatch = e.target.closest('.product-card__swatch[data-swatch-image]');
    if (!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    var card = swatch.closest('.product-card');
    if (!card) return;
    var primaryImg = card.querySelector('.product-card__image--primary');
    if (primaryImg) primaryImg.src = swatch.dataset.swatchImage;
    card.querySelectorAll('.product-card__swatch').forEach(function(s) { s.classList.remove('is-active'); });
    swatch.classList.add('is-active');
  });

  /* --- ADD TO CART (AJAX) --- */
  var addToCartForm = document.querySelector('.product-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var atcBtn = addToCartForm.querySelector('.product-atc');
      var atcText = addToCartForm.querySelector('.product-atc__text');
      var variantId = addToCartForm.querySelector('input[name="id"]').value;

      if (atcBtn.disabled) return;
      atcBtn.disabled = true;
      var originalText = atcText ? atcText.textContent : '';
      if (atcText) atcText.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
      .then(function(response) {
        if (!response.ok) return response.json().then(function(err) { throw err; });
        return response.json();
      })
      .then(function() {
        if (atcText) atcText.textContent = 'Added ✓';
        // Fetch updated cart, refresh count and open drawer
        fetch('/cart.js?_=' + Date.now()).then(function(r) { return r.json(); }).then(function(cart) {          var countEl = document.querySelector('.header__cart-count');
          if (countEl) {
            countEl.textContent = cart.item_count;
            countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
          if (window.cartDrawer) window.cartDrawer.open(cart);
        });
        setTimeout(function() {
          if (atcText) atcText.textContent = originalText;
          atcBtn.disabled = false;
        }, 2000);
      })
      .catch(function(err) {
        var msg = (err && err.description) || 'This variant is sold out.';
        if (atcText) atcText.textContent = msg;
        setTimeout(function() {
          if (atcText) atcText.textContent = originalText;
          atcBtn.disabled = false;
        }, 3000);
      });
    });
  }

  /* --- COLLECTION FILTERS (Mobile Toggle) --- */
  var filterToggle = document.querySelector('.collection-filters__mobile-toggle');
  var filtersPanel = document.querySelector('.collection-filters');

  if (filterToggle && filtersPanel) {
    filterToggle.addEventListener('click', function() {
      filtersPanel.classList.toggle('is-open');
      this.textContent = filtersPanel.classList.contains('is-open') ? '✕ Close Filters' : '☰ Filter';
    });
  }

  /* --- COLLECTION FILTER: Form-based navigation + client-side size filter --- */
  var filterForm = document.querySelector('[data-collection-filters-form]');
  if (filterForm) {
    function buildFilterUrl() {
      var url = new URL(window.location.pathname, window.location.origin);
      // Collect all checked checkboxes (exclude size filters - those are client-side)
      filterForm.querySelectorAll('input[type="checkbox"]:checked:not([data-size-filter])').forEach(function(cb) {
        url.searchParams.append(cb.name, cb.value);
      });
      // Collect price range values
      var priceFilter = filterForm.querySelector('[data-price-filter]');
      if (priceFilter) {
        var minThumb = priceFilter.querySelector('.price-range__thumb--min');
        var maxThumb = priceFilter.querySelector('.price-range__thumb--max');
        var rangeMin = parseFloat(priceFilter.dataset.min) || 0;
        var rangeMax = parseFloat(priceFilter.dataset.max) || 0;
        if (minThumb && parseFloat(minThumb.value) > rangeMin) {
          url.searchParams.set(minThumb.name, minThumb.value);
        }
        if (maxThumb && parseFloat(maxThumb.value) < rangeMax) {
          url.searchParams.set(maxThumb.name, maxThumb.value);
        }
      }
      return url.toString();
    }

    // Storefront API checkboxes (availability etc.) → navigate
    filterForm.querySelectorAll('input[type="checkbox"]:not([data-size-filter])').forEach(function(checkbox) {
      checkbox.addEventListener('change', function() {
        window.location.href = buildFilterUrl();
      });
    });

    // Client-side size filtering
    var sizeCheckboxes = filterForm.querySelectorAll('[data-size-filter]');
    if (sizeCheckboxes.length > 0) {
      function filterBySize() {
        var selectedSizes = [];
        sizeCheckboxes.forEach(function(cb) {
          if (cb.checked) selectedSizes.push(cb.value);
        });

        var items = document.querySelectorAll('.collection-grid__item[data-product-sizes]');
        var visibleCount = 0;
        items.forEach(function(item) {
          if (selectedSizes.length === 0) {
            item.style.display = '';
            visibleCount++;
            return;
          }
          var sizesAttr = item.dataset.productSizes;
          // Products without sizes are always shown
          if (!sizesAttr || sizesAttr === '') {
            item.style.display = '';
            visibleCount++;
            return;
          }
          var productSizes = sizesAttr.split(',');
          var match = selectedSizes.some(function(s) {
            return productSizes.indexOf(s) !== -1;
          });
          item.style.display = match ? '' : 'none';
          if (match) visibleCount++;
        });

        // Show/hide no results message
        var grid = document.querySelector('.collection-grid');
        var noResults = grid ? grid.querySelector('.collection-no-results') : null;
        if (visibleCount === 0 && items.length > 0) {
          if (!noResults) {
            noResults = document.createElement('p');
            noResults.className = 'collection-no-results';
            noResults.textContent = 'No products match the selected filters.';
            grid.appendChild(noResults);
          }
          noResults.style.display = '';
        } else if (noResults) {
          noResults.style.display = 'none';
        }
      }

      sizeCheckboxes.forEach(function(cb) {
        cb.addEventListener('change', filterBySize);
      });
    }

    // Price range slider
    var priceFilter = filterForm.querySelector('[data-price-filter]');
    if (priceFilter) {
      var minThumb = priceFilter.querySelector('.price-range__thumb--min');
      var maxThumb = priceFilter.querySelector('.price-range__thumb--max');
      var track = priceFilter.querySelector('.price-range__track');
      var displayMin = priceFilter.querySelector('[data-price-display-min]');
      var displayMax = priceFilter.querySelector('[data-price-display-max]');
      var debounceTimer = null;

      function updatePriceTrack() {
        var min = parseFloat(minThumb.value);
        var max = parseFloat(maxThumb.value);
        var rangeMin = parseFloat(minThumb.min);
        var rangeMax = parseFloat(minThumb.max);
        var total = rangeMax - rangeMin;
        if (total <= 0) return;
        var left = ((min - rangeMin) / total) * 100;
        var right = ((rangeMax - max) / total) * 100;
        track.style.left = left + '%';
        track.style.right = right + '%';
        if (displayMin) displayMin.textContent = Math.round(min);
        if (displayMax) displayMax.textContent = Math.round(max);
      }

      function onThumbInput() {
        var min = parseFloat(minThumb.value);
        var max = parseFloat(maxThumb.value);
        if (min > max) {
          if (this === minThumb) minThumb.value = max;
          else maxThumb.value = min;
        }
        updatePriceTrack();
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          window.location.href = buildFilterUrl();
        }, 800);
      }

      if (minThumb && maxThumb) {
        minThumb.addEventListener('input', onThumbInput);
        maxThumb.addEventListener('input', onThumbInput);
        updatePriceTrack();
      }
    }
  }

  /* --- NEW ARRIVALS MARQUEE --- */
  function initNaMarquees(container) {
    var root = container || document;
    root.querySelectorAll('[data-na-marquee]').forEach(function(carousel) {
      if (carousel.dataset.marqueeInitialized) return;
      carousel.dataset.marqueeInitialized = 'true';

      var track = carousel.querySelector('.new-arrivals__carousel-track');
      if (!track) return;

      var speed = parseFloat(carousel.getAttribute('data-autoplay-speed')) || 5;
      var items = Array.from(track.querySelectorAll('.new-arrivals__carousel-item'));
      if (items.length === 0) return;

      // Set item width based on container and --items-per-row
      var resizeTicking = false;
      function setItemWidths() {
        var perRow = parseInt(getComputedStyle(carousel).getPropertyValue('--items-per-row')) || 3;
        if (window.innerWidth <= 768) perRow = 2;
        var gap = 24;
        var itemWidth = (carousel.offsetWidth - gap * (perRow - 1)) / perRow;
        track.querySelectorAll('.new-arrivals__carousel-item').forEach(function(item) {
          item.style.width = itemWidth + 'px';
          item.style.flex = '0 0 ' + itemWidth + 'px';
        });
        // Duration proportional to number of original items
        var duration = speed * items.length;
        track.style.animationDuration = duration + 's';
        resizeTicking = false;
      }

      // Duplicate items for seamless loop (only once!)
      items.forEach(function(item) {
        var clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });

      setItemWidths();
      window.addEventListener('resize', function() {
        if (!resizeTicking) {
          resizeTicking = true;
          requestAnimationFrame(setItemWidths);
        }
      }, { passive: true });

      // Pause CSS animation when scrolled off-screen
      if ('IntersectionObserver' in window) {
        var marqueeObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              track.classList.remove('is-offscreen');
            } else {
              track.classList.add('is-offscreen');
            }
          });
        }, { rootMargin: '100px 0px' });
        marqueeObserver.observe(carousel);
      }

      // Pause on hover
      carousel.addEventListener('mouseenter', function() {
        track.classList.add('is-paused');
      });
      carousel.addEventListener('mouseleave', function() {
        track.classList.remove('is-paused');
      });

      // Pause on touch (mobile)
      carousel.addEventListener('touchstart', function() {
        track.classList.add('is-paused');
      }, { passive: true });
      carousel.addEventListener('touchend', function() {
        track.classList.remove('is-paused');
      }, { passive: true });
    });
  }
  initNaMarquees();

  /* --- CAROUSEL NAVIGATION (generic) --- */
  function initGenericCarousels(container) {
    var root = container || document;
    root.querySelectorAll('[data-carousel]').forEach(function(carousel) {
      if (carousel.dataset.carouselInitialized) return;
      carousel.dataset.carouselInitialized = 'true';

      var track = carousel.querySelector('.about-carousel__track, .new-arrivals__carousel-track, .bestsellers__track');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      var desktopSlides = parseInt(carousel.getAttribute('data-slides-to-show')) || 3;
      var mobileSlides = parseInt(carousel.getAttribute('data-mobile-slides')) || 1;
      var gap = 16;
      var items = track.querySelectorAll('.about-carousel__item');

      function getActiveSlidesToShow() {
        return window.innerWidth <= 768 ? mobileSlides : desktopSlides;
      }

      var resizeTicking = false;
      function updateItemWidths() {
        var slidesToShow = getActiveSlidesToShow();
        var trackWidth = track.clientWidth;
        var itemWidth = (trackWidth - gap * (slidesToShow - 1)) / slidesToShow;
        items.forEach(function(item) {
          item.style.flex = '0 0 ' + itemWidth + 'px';
          item.style.minWidth = itemWidth + 'px';
        });
        resizeTicking = false;
      }

      if (items.length > 0) {
        updateItemWidths();
        window.addEventListener('resize', function() {
          if (!resizeTicking) {
            resizeTicking = true;
            requestAnimationFrame(updateItemWidths);
          }
        }, { passive: true });
      }

      var scrollAmount = function() {
        var firstItem = track.querySelector('.about-carousel__item, .new-arrivals__carousel-item');
        return firstItem ? firstItem.offsetWidth + gap : 300;
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
      }

      /* autoplay */
      var autoplayEnabled = carousel.getAttribute('data-autoplay');
      var autoplaySpeed = parseInt(carousel.getAttribute('data-autoplay-speed')) || 4;
      if (autoplayEnabled === 'true') {
        var autoTimer = null;
        var isHoveredOrTouched = false;
        var isVisible = true;

        function startAutoplay() {
          if (autoTimer || isHoveredOrTouched || !isVisible) return;
          autoTimer = setInterval(function() {
            var maxScroll = track.scrollWidth - track.clientWidth;
            if (track.scrollLeft >= maxScroll - 2) {
              track.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
            }
          }, autoplaySpeed * 1000);
        }

        function stopAutoplay() {
          if (autoTimer) {
            clearInterval(autoTimer);
            autoTimer = null;
          }
        }

        carousel.addEventListener('mouseenter', function() {
          isHoveredOrTouched = true;
          stopAutoplay();
        });
        carousel.addEventListener('mouseleave', function() {
          isHoveredOrTouched = false;
          startAutoplay();
        });
        track.addEventListener('touchstart', function() {
          isHoveredOrTouched = true;
          stopAutoplay();
        }, { passive: true });
        track.addEventListener('touchend', function() {
          isHoveredOrTouched = false;
          startAutoplay();
        }, { passive: true });
        if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); startAutoplay(); });
        if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); startAutoplay(); });

        // Pause autoplay when carousel is not visible on screen
        if ('IntersectionObserver' in window) {
          var carouselObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
              isVisible = entry.isIntersecting;
              if (isVisible) {
                startAutoplay();
              } else {
                stopAutoplay();
              }
            });
          }, { rootMargin: '50px 0px' });
          carouselObserver.observe(carousel);
        } else {
          startAutoplay();
        }
      }
    });
  }
  initGenericCarousels();

  /* --- NEWSLETTER FORM --- */
  var newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      // Shopify handles this, but add basic validation
      var emailInput = this.querySelector('.newsletter__input');
      if (emailInput && !emailInput.value.trim()) {
        e.preventDefault();
        emailInput.style.borderColor = '#ff4444';
        setTimeout(function() { emailInput.style.borderColor = ''; }, 2000);
      }
    });
  }

  /* --- SMOOTH SCROLL FOR ANCHOR LINKS --- */
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ==========================================
     FIT GUIDE – Carousels & Interactions
     ========================================== */

  /* --- FG Specs Finish Carousel --- */
  function initFitGuideCarousels(container) {
    var root = container || document;
    root.querySelectorAll('[data-fg-carousel]').forEach(function(carousel) {
      if (carousel.dataset.fgCarouselInitialized) return;
      carousel.dataset.fgCarouselInitialized = 'true';

      var track = carousel.querySelector('.fg-specs__carousel-track');
      if (!track) return;

      var cards = track.querySelectorAll('.fg-specs__finish-card');
      var section = carousel.closest('.fg-specs');
      var prevBtn = section ? section.querySelector('[data-fg-carousel-prev]') : null;
      var nextBtn = section ? section.querySelector('[data-fg-carousel-next]') : null;
      var desktopSlides = parseInt(carousel.getAttribute('data-slides-to-show')) || 2;
      var mobileSlides = parseInt(carousel.getAttribute('data-mobile-slides')) || 1;
      var gap = 20;
      var index = 0;

      function getSlidesToShow() {
        return window.innerWidth <= 768 ? mobileSlides : desktopSlides;
      }

      function getMaxIndex() {
        return Math.max(0, cards.length - getSlidesToShow());
      }

      function updateTrack() {
        if (!cards.length) return;
        var s = getSlidesToShow();
        var cardWidth = (track.clientWidth - gap * (s - 1)) / s;
        var offset = index * (cardWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function setCardWidths() {
        var s = getSlidesToShow();
        var cardWidth = (track.clientWidth - gap * (s - 1)) / s;
        cards.forEach(function(card) {
          card.style.flex = '0 0 ' + cardWidth + 'px';
        });
      }

      if (cards.length) {
        setCardWidths();
        var resizeTicking = false;
        window.addEventListener('resize', function() {
          if (!resizeTicking) {
            resizeTicking = true;
            requestAnimationFrame(function() {
              setCardWidths();
              if (index > getMaxIndex()) index = getMaxIndex();
              updateTrack();
              resizeTicking = false;
            });
          }
        }, { passive: true });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          index = Math.max(0, index - 1);
          updateTrack();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          index = Math.min(getMaxIndex(), index + 1);
          updateTrack();
        });
      }
    });

    /* --- FG Styles Carousel --- */
    root.querySelectorAll('[data-fg-styles-carousel]').forEach(function(carousel) {
      if (carousel.dataset.fgStylesInitialized) return;
      carousel.dataset.fgStylesInitialized = 'true';

      var track = carousel.querySelector('.fg-styles__track');
      if (!track) return;

      var cards = track.querySelectorAll('.fg-styles__card');
      var section = carousel.closest('.fg-styles');
      var prevBtn = section ? section.querySelector('[data-fg-styles-prev]') : null;
      var nextBtn = section ? section.querySelector('[data-fg-styles-next]') : null;
      var desktopSlides = parseInt(carousel.getAttribute('data-slides-to-show')) || 4;
      var mobileSlides = parseInt(carousel.getAttribute('data-mobile-slides')) || 2;
      var gap = 20;
      var index = 0;

      function getSlidesToShow() {
        return window.innerWidth <= 768 ? mobileSlides : desktopSlides;
      }

      function getMaxIndex() {
        return Math.max(0, cards.length - getSlidesToShow());
      }

      function updateTrack() {
        if (!cards.length) return;
        var slidesToShow = getSlidesToShow();
        var cardWidth = (track.clientWidth - gap * (slidesToShow - 1)) / slidesToShow;
        var offset = index * (cardWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';
      }

      function setCardWidths() {
        var slidesToShow = getSlidesToShow();
        var cardWidth = (track.clientWidth - gap * (slidesToShow - 1)) / slidesToShow;
        cards.forEach(function(card) {
          card.style.flex = '0 0 ' + cardWidth + 'px';
        });
      }

      if (cards.length) {
        setCardWidths();
        var resizeTicking = false;
        window.addEventListener('resize', function() {
          if (!resizeTicking) {
            resizeTicking = true;
            requestAnimationFrame(function() {
              setCardWidths();
              if (index > getMaxIndex()) index = getMaxIndex();
              updateTrack();
              resizeTicking = false;
            });
          }
        }, { passive: true });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          index = Math.max(0, index - 1);
          updateTrack();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          index = Math.min(getMaxIndex(), index + 1);
          updateTrack();
        });
      }
    });
  }
  initFitGuideCarousels();

  /* --- FG Hero Nav Dots – active on scroll --- */
  var fgNavDots = document.querySelectorAll('[data-fg-nav-dot]');
  if (fgNavDots.length) {
    var fgSections = [];
    fgNavDots.forEach(function(dot) {
      var href = dot.getAttribute('href');
      if (href && href.startsWith('#')) {
        var target = document.getElementById(href.substring(1));
        if (target) fgSections.push({ dot: dot, el: target });
      }
    });

    if (fgSections.length) {
      var currentActiveDot = null;
      var fgScrollTicking = false;

      var updateFgActiveDot = function() {
        var scrollPos = window.scrollY + window.innerHeight * 0.35;
        var active = fgSections[0];
        for (var i = 0; i < fgSections.length; i++) {
          if (fgSections[i].el.offsetTop <= scrollPos) {
            active = fgSections[i];
          }
        }
        if (active && active.dot !== currentActiveDot) {
          if (currentActiveDot) currentActiveDot.classList.remove('is-active');
          active.dot.classList.add('is-active');
          currentActiveDot = active.dot;
        }
        fgScrollTicking = false;
      };

      var fgScrollHandler = function() {
        if (!fgScrollTicking) {
          fgScrollTicking = true;
          requestAnimationFrame(updateFgActiveDot);
        }
      };

      window.addEventListener('scroll', fgScrollHandler, { passive: true });
      updateFgActiveDot();
    }
  }

  /* --- FG Video Play --- */
  document.querySelectorAll('[data-fg-video-play]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var player = this.closest('[data-fg-video]');
      if (!player) return;

      var url = this.getAttribute('data-video-url');
      if (!url) return;

      var poster = player.querySelector('.fg-videos__poster, .fg-videos__poster-placeholder');

      // Determine embed type
      var youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
      var vimeoMatch = url.match(/vimeo\.com\/(\d+)/);

      if (youtubeMatch) {
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + youtubeMatch[1] + '?autoplay=1&rel=0';
        iframe.allow = 'autoplay; encrypted-media';
        iframe.allowFullscreen = true;
        if (poster) poster.style.display = 'none';
        this.style.display = 'none';
        player.appendChild(iframe);
      } else if (vimeoMatch) {
        var iframe = document.createElement('iframe');
        iframe.src = 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
        iframe.allow = 'autoplay; encrypted-media; fullscreen';
        if (poster) poster.style.display = 'none';
        this.style.display = 'none';
        player.appendChild(iframe);
      } else {
        // Assume direct mp4
        var video = document.createElement('video');
        video.src = url;
        video.loop = true;  
        video.autoplay = true;
        video.controls = false;
        video.playsInline = true;
        if (poster) poster.style.display = 'none';
        this.style.display = 'none';
        player.appendChild(video);
      }
    });
  });

/* --- CART DRAWER --- */
  (function() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');
    var itemsEl = document.getElementById('cart-drawer-items');
    var footerEl = document.getElementById('cart-drawer-footer');
    var shippingBar = document.getElementById('cart-drawer-shipping-bar');
    var shippingMsg = document.getElementById('cart-drawer-shipping-msg');
    var cartToggle = document.querySelector('.header__cart-toggle');

    if (!drawer) return;

    // Funkcja pobiera aktualne ustawienia w locie (zapobiega to używaniu starych wartości)
    function getCartSettings() {
      return window.__cartSettings || { 
        freeShippingThreshold: 50000, 
        currency: 'PLN', 
        currencySymbol: 'zł',
        strings: {} 
      };
    }

    function cartString(key, fallback, replacements) {
      var activeSettings = getCartSettings();
      var strings = activeSettings.strings || {};
      var value = strings[key] || fallback;
      if (replacements) {
        Object.keys(replacements).forEach(function(name) {
          value = value.replace(new RegExp('{{\\s*' + name + '\\s*}}', 'g'), replacements[name]);
        });
      }
      return value;
    }

    // Dynamiczne i uniwersalne formatowanie cen dla EUR, PLN i innych walut
    function formatMoney(cents) {
      var activeSettings = getCartSettings();
      var amount = (cents / 100).toFixed(2).replace('.', ',');
      var symbol = activeSettings.currencySymbol || 'zł';
      var currencyCode = activeSettings.currency || 'PLN';

      // Obsługa formatu Euro (np. € 12,34 lub €12,34)
      if (currencyCode === 'EUR') {
        return '€' + amount;
      }
      
      // Obsługa formatu PLN i innych walut (np. 12,34 zł)
      return amount + '\u00a0' + symbol;
    }

    function updateShippingBar(total) {
      var activeSettings = getCartSettings();
      var threshold = activeSettings.freeShippingThreshold;
      shippingBar.classList.add('is-visible');
      if (total >= threshold) {
        shippingMsg.textContent = cartString('freeShippingReached', 'Masz bezpłatną dostawę!');
      } else {
        var remaining = formatMoney(threshold - total);
        shippingMsg.innerHTML = cartString('freeShippingRemainingHtml', 'Wydaj jeszcze <strong>{{ amount }}</strong>, aby uzyskać bezpłatną dostawę!', { amount: remaining });
      }
    }

    function renderItems(cart) {
      currentCart = cart;
      if (!cart || cart.item_count === 0) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty">' + escapeHtml(cartString('empty', 'Tw\u00f3j koszyk jest pusty')) + '</div>';
        renderFooter(null);
        return;
      }

      var html = '';
      var renderedPacks = {};

      cart.items.forEach(function(item) {
        var bundleId = item.properties && item.properties._bundle_id ? item.properties._bundle_id : '';
        var isMultipack = bundleId && bundleId.indexOf('pack_') === 0;

        if (isMultipack) {
          if (renderedPacks[bundleId]) return;
          renderedPacks[bundleId] = true;
          var packItems = cart.items.filter(function(i) {
            return i.properties && i.properties._bundle_id === bundleId;
          });
          html += renderPackCard(packItems, bundleId);
        } else {
          html += renderSingleCard(item);
        }
      });

      itemsEl.innerHTML = html;
      renderFooter(cart);
    }

    function renderPackCard(packItems, bundleId) {
      var firstItem = packItems[0];
      var discountPercent = firstItem.properties && firstItem.properties._multipack_discount_percent
        ? parseFloat(firstItem.properties._multipack_discount_percent) : 0;

      var totalPackCount = 0;
      var totalOriginal = 0;
      var totalFinal = 0;
      packItems.forEach(function(item) {
        totalPackCount += item.quantity;
        totalOriginal += item.original_price * item.quantity;
        totalFinal += item.final_price * item.quantity;
      });

      var visualOriginal = totalOriginal;
      var visualDiscounted = totalFinal;
      if (discountPercent > 0 && totalOriginal === totalFinal) {
        visualDiscounted = Math.round(totalOriginal * (100 - discountPercent) / 100);
      }
      var discountAmount = visualOriginal - visualDiscounted;

      var fallbackImage = firstItem.image;
      var imgHtml = '<div class="cart-drawer__pack-images">';
      packItems.forEach(function(item) {
        var src = (item.image || fallbackImage);
        if (src) {
          var imgSrc = src.replace(/(\.jpg|\.jpeg|\.png|\.webp)/, '_160x$1');
          var renderTimes = packItems.length === 1 && item.quantity > 1 ? item.quantity : 1;
          for (var q = 0; q < renderTimes; q++) {
            imgHtml += '<img src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" loading="lazy">';
          }
        }
      });
      imgHtml += '</div>';

      var variantsHtml = packItems.map(function(item, idx) {
        var label = item.variant_title && item.variant_title !== 'Default Title'
          ? item.variant_title : item.product_title;
        var isLast = idx === packItems.length - 1;
        var qtyPrefix = (item.quantity > 1 ? item.quantity + 'x ' : '1x ');
        return '<div class="cart-drawer__pack-variant">' +
          qtyPrefix + escapeHtml(label) +
          (isLast ? ' <button type="button" class="cart-drawer__item-remove" data-bundle-id="' + escapeHtml(bundleId) + '">' + escapeHtml(cartString('remove', 'USU\u0143')) + '</button>' : '') +
          '</div>';
      }).join('');

      var pricingHtml = '';
      if (discountAmount > 0) {
        pricingHtml =
          '<div class="cart-drawer__pack-pricing">' +
            '<span class="cart-drawer__pack-pricing-label">' + escapeHtml(cartString('packDiscountLabel', '\u0141\u0105czne rabaty za {{ count }}-pak:', { count: totalPackCount })) + '</span>' +
            '<div>' +
              '<span class="cart-drawer__item-price--compare">' + formatMoney(visualOriginal) + '</span>' +
              ' <span>' + formatMoney(visualDiscounted) + '</span>' +
              ' <span style="font-weight:bold;color:#8B0000;">' + escapeHtml(cartString('discount', 'Rabat')) + ': -' + formatMoney(discountAmount) + '</span>' +
            '</div>' +
          '</div>';
      }

      var html = '';
      html += '<div class="cart-drawer__item cart-drawer__item--pack" data-bundle-id="' + escapeHtml(bundleId) + '">';
      html += '<div class="cart-drawer__item-img">' + imgHtml + '</div>';
      html += '<div class="cart-drawer__item-details">';
      html += '<div class="cart-drawer__item-name">' + escapeHtml(firstItem.product_title) + ' <span class="cart-bundle-tag">' + escapeHtml(cartString('packTag', '{{ count }}-PAK', { count: totalPackCount })) + '</span></div>';
      html += '<div class="cart-drawer__pack-variants"><p class="cart-drawer__pack-label">' + escapeHtml(cartString('packItemsLabel', 'Kupujesz:')) + '</p>' + variantsHtml + '</div>';
      html += '<div class="cart-drawer__item-bottom">';
      html += '<div class="cart-drawer__item-qty">';
      html += '<button type="button" class="cart-drawer__qty-btn" data-bundle-id="' + escapeHtml(bundleId) + '" data-action="decrease" aria-label="' + escapeHtml(cartString('removeBundle', 'Usu\u0144 zestaw')) + '">&minus;</button>';
      html += '<span class="cart-drawer__qty-val">1</span>';
      html += '<button type="button" class="cart-drawer__qty-btn" data-bundle-id="' + escapeHtml(bundleId) + '" data-action="increase" aria-label="' + escapeHtml(cartString('increaseQuantity', 'Zwi\u0119ksz')) + '" disabled style="opacity:0.3;cursor:not-allowed">+</button>';
      html += '</div>';
      html += '</div>';
      html += pricingHtml;
      html += '</div>';
      html += '</div>';
      return html;
    }

    function renderSingleCard(item) {
      var bundleId = item.properties && item.properties._bundle_id ? item.properties._bundle_id : '';
      var priceHtml = '';
      var bundleDiscountPercent = item.properties && item.properties._bundle_discount_percent
        ? parseFloat(item.properties._bundle_discount_percent) : 0;

      if (item.original_price > item.final_price) {
        var discountAmount = item.original_price - item.final_price;
        priceHtml = '<span class="cart-drawer__item-price--compare">' + formatMoney(item.original_price) + '</span>' +
          '<span>' + formatMoney(item.final_price) + '</span>' +
          '<span style="font-weight:bold;color:#8B0000;display:block;">' + escapeHtml(cartString('discount', 'Rabat')) + ': -' + formatMoney(discountAmount) + '</span>';
      } else if (bundleDiscountPercent > 0) {
        var estimatedDiscount = Math.round(item.final_price * bundleDiscountPercent / 100);
        var discountedPrice = item.final_price - estimatedDiscount;
        priceHtml = '<span class="cart-drawer__item-price--compare">' + formatMoney(item.final_price) + '</span>' +
          '<span>' + formatMoney(discountedPrice) + '</span>' +
          '<span style="font-weight:bold;color:#8B0000;display:block;">' + escapeHtml(cartString('discount', 'Rabat')) + ': -' + formatMoney(estimatedDiscount) + '</span>';
      } else {
        priceHtml = '<span>' + formatMoney(item.final_price) + '</span>';
      }

      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';

      var imgHtml = '';
      if (item.image) {
        var imgSrc = item.image.replace(/(\.jpg|\.jpeg|\.png|\.webp)/, '_200x$1');
        imgHtml = '<img src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="90" height="110">';
      }

      var html = '';
      html += '<div class="cart-drawer__item" data-key="' + item.key + '"' + (bundleId ? ' data-bundle-id="' + escapeHtml(bundleId) + '"' : '') + '>';
      html += '<div class="cart-drawer__item-img">' + imgHtml + '</div>';
      html += '<div class="cart-drawer__item-details">';
      html += '<div class="cart-drawer__item-name">' + escapeHtml(item.product_title) + (bundleId ? ' <span class="cart-bundle-tag">' + escapeHtml(cartString('bundleTag', 'ZESTAW')) + '</span>' : '') + '</div>';
      html += '<div class="cart-drawer__item-prices">' + priceHtml + '</div>';
      html += variantHtml;
      html += '<div class="cart-drawer__item-bottom">';
      html += '<div class="cart-drawer__item-qty">';
      html += '<button type="button" class="cart-drawer__qty-btn" data-key="' + item.key + '" data-action="decrease" aria-label="' + escapeHtml(cartString('decreaseQuantity', 'Zmniejsz')) + '">&minus;</button>';
      html += '<span class="cart-drawer__qty-val">' + item.quantity + '</span>';
      html += '<button type="button" class="cart-drawer__qty-btn" data-key="' + item.key + '" data-action="increase" aria-label="' + escapeHtml(cartString('increaseQuantity', 'Zwi\u0119ksz')) + '"' + (bundleId ? ' disabled style="opacity:0.3;cursor:not-allowed"' : '') + '>+</button>';
      html += '</div>';
      html += '<button type="button" class="cart-drawer__item-remove" data-key="' + item.key + '">' + escapeHtml(cartString('remove', 'USU\u0143')) + '</button>';
      html += '</div>';
      html += '</div>';
      html += '</div>';
      return html;
    }

    function renderFooter(cart) {
      if (!cart || cart.item_count === 0) {
        footerEl.innerHTML = '';
        return;
      }

      var termId = 'cart-terms-' + Date.now();

      var visualTotal = cart.total_price;
      var bundleGroups = {};

      cart.items.forEach(function(item) {
        var bundleId = item.properties && item.properties._bundle_id ? item.properties._bundle_id : '';
        var discountPercent = item.properties && item.properties._multipack_discount_percent
          ? parseFloat(item.properties._multipack_discount_percent)
          : item.properties && item.properties._bundle_discount_percent
            ? parseFloat(item.properties._bundle_discount_percent)
            : 0;

        if (bundleId && discountPercent > 0 && !(item.original_price > item.final_price)) {
          if (!bundleGroups[bundleId]) {
            bundleGroups[bundleId] = {
              percent: discountPercent,
              total: 0
            };
          }
          bundleGroups[bundleId].total += item.final_price * item.quantity;
        } else if (!bundleId && discountPercent > 0 && !(item.original_price > item.final_price)) {
          var estimatedDiscount = Math.round(item.final_price * discountPercent / 100);
          visualTotal -= estimatedDiscount * item.quantity;
        }
      });

      Object.keys(bundleGroups).forEach(function(bId) {
        var group = bundleGroups[bId];
        var discounted = Math.round(group.total * (100 - group.percent) / 100);
        var discountAmount = group.total - discounted;
        visualTotal -= discountAmount;
      });

      updateShippingBar(visualTotal);

      var html = '';
      html += '<button type="button" class="cart-drawer__notes-toggle" id="cart-notes-toggle">' + escapeHtml(cartString('notesToggle', 'DODAJ UWAGI DO ZAM\u00d3WIENIA')) + '</button>';
      html += '<textarea class="cart-drawer__notes-textarea is-open" id="cart-notes-textarea" name="note" placeholder="' + escapeHtml(cartString('notesPlaceholder', 'Twoje uwagi...')) + '" rows="3"></textarea>';
      html += '<p class="cart-drawer__tax-note">' + escapeHtml(cartString('taxNote', 'Podatki i koszty wysy\u0142ki obliczane przy realizacji zakupu')) + '</p>';
      html += '<input type="text" class="cart-drawer__discount" placeholder="' + escapeHtml(cartString('discountPlaceholder', 'Kod rabatowy')) + '">';
      html += '<div class="cart-drawer__total-row">';
      html += '<span class="cart-drawer__total-label">' + escapeHtml(cartString('total', 'TOTAL')) + ' (' + escapeHtml(getCartSettings().currency) + ')</span>';
      html += '<span class="cart-drawer__total-price">' + formatMoney(visualTotal) + '</span>';
      html += '</div>';
      html += '<div class="cart-drawer__terms">';
      html += '<input type="checkbox" id="' + termId + '">';
      html += '<label for="' + termId + '">' + cartString('termsHtml', 'AKCEPTUJ\u0118 <a href="/pages/regulamin">REGULAMIN</a> ORAZ <a href="/pages/polityka-prywatnosci">POLITYK\u0118 PRYWATNO\u015aCI</a>') + '</label>';
      html += '</div>';
      html += '<button type="button" class="cart-drawer__checkout" id="cart-drawer-checkout">' + escapeHtml(cartString('checkout', 'PRZEJD\u017b DALEJ')) + '</button>';

      footerEl.innerHTML = html;
    }

    function removeBundleAwareItem(key, bundleId) {
      if (bundleId && currentCart) {
        var updates = {};
        currentCart.items.forEach(function(i) {
          if (i.properties && i.properties._bundle_id === bundleId) {
            updates[i.key] = 0;
          }
        });
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          updateCartCount(cart.item_count);
          updateShippingBar(cart.total_price);
          renderItems(cart);
        });
      } else {
        updateItemQty(key, 0);
      }
    }

    function updateItemQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        updateCartCount(cart.item_count);
        updateShippingBar(cart.total_price);
        renderItems(cart);
      });
    }

    function updateCartCount(count) {
      var countEl = document.querySelector('.header__cart-count');
      if (countEl) {
        countEl.textContent = count;
        countEl.style.display = count > 0 ? 'flex' : 'none';
      }
    }

    function open(cartData) {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (cartData) {
        updateShippingBar(cartData.total_price);
        renderItems(cartData);
      } else {
        itemsEl.innerHTML = '<div class="cart-drawer__loading">' + escapeHtml(cartString('loading', '\u0141adowanie...')) + '</div>';
        fetch('/cart.js?_=' + Date.now())
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            updateShippingBar(cart.total_price);
            renderItems(cart);
          });
      }
    }

    function close() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    if (cartToggle) cartToggle.addEventListener('click', function() { open(); });

    // Delegated event listener for cart items (qty & remove)
    if (itemsEl) {
      itemsEl.addEventListener('click', function(e) {
        var qtyBtn = e.target.closest('.cart-drawer__qty-btn');
        if (qtyBtn) {
          var packBundleId = qtyBtn.dataset.bundleId || null;
          var action = qtyBtn.dataset.action;

          if (packBundleId) {
            if (action === 'decrease') removeBundleAwareItem(null, packBundleId);
            return;
          }

          var key = qtyBtn.dataset.key;
          var qtyParent = qtyBtn.parentElement;
          var qtyEl = qtyParent ? qtyParent.querySelector('.cart-drawer__qty-val') : null;
          var currentQty = qtyEl ? (parseInt(qtyEl.textContent) || 0) : 0;
          var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
          if (newQty === 0) {
            var itemEl = qtyBtn.closest('.cart-drawer__item');
            removeBundleAwareItem(key, itemEl ? itemEl.dataset.bundleId : null);
          } else {
            updateItemQty(key, newQty);
          }
          return;
        }

        var removeBtn = e.target.closest('.cart-drawer__item-remove');
        if (removeBtn) {
          var key = removeBtn.dataset.key || null;
          var bundleId = removeBtn.dataset.bundleId || null;
          if (!bundleId) {
            var itemEl = removeBtn.closest('.cart-drawer__item');
            bundleId = itemEl ? itemEl.dataset.bundleId : null;
          }
          removeBundleAwareItem(key, bundleId);
        }
      });
    }

    // Delegated event listener for cart footer (notes & checkout)
    if (footerEl) {
      footerEl.addEventListener('click', function(e) {
        var notesToggle = e.target.closest('#cart-notes-toggle');
        if (notesToggle) {
          var notesTextarea = document.getElementById('cart-notes-textarea');
          if (notesTextarea) {
            notesTextarea.classList.toggle('is-open');
            if (notesTextarea.classList.contains('is-open')) notesTextarea.focus();
          }
          return;
        }

        var checkoutBtn = e.target.closest('#cart-drawer-checkout');
        if (checkoutBtn) {
          var termsCheckbox = footerEl.querySelector('input[type="checkbox"]');
          if (!termsCheckbox || !termsCheckbox.checked) {
            checkoutBtn.classList.remove('shake');
            void checkoutBtn.offsetWidth;
            checkoutBtn.classList.add('shake');
            return;
          }
          var notesTextarea = document.getElementById('cart-notes-textarea');
          var note = notesTextarea ? notesTextarea.value : '';
          var bundleDiscount = '';
          if (currentCart) {
            currentCart.items.forEach(function(i) {
              if (!bundleDiscount && i.properties && i.properties._bundle_discount) {
                bundleDiscount = i.properties._bundle_discount;
              }
              if (!bundleDiscount && i.properties && i.properties._multipack_discount) {
                bundleDiscount = i.properties._multipack_discount;
              }
            });
          }
          var params = [];
          if (bundleDiscount) params.push('discount=' + encodeURIComponent(bundleDiscount));
          if (note) params.push('note=' + encodeURIComponent(note));
          var url = '/checkout' + (params.length ? '?' + params.join('&') : '');
          window.location.href = url;
        }
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    window.cartDrawer = { open: open, close: close, updateCartCount: updateCartCount };
  }());

  /* --- BUNDLE PICKER --- */
  (function () {
    var bundlePicker = document.querySelector('[data-bundle-picker]');
    if (!bundlePicker) return;

    var moneyFormat = bundlePicker.dataset.moneyFormat || '{{ amount }}';
    var discountCode = bundlePicker.dataset.bundleDiscount || '';
    var discountPercent = parseFloat(bundlePicker.dataset.bundleDiscountPercent) || 0;
    var totalEl = bundlePicker.querySelector('[data-bundle-total]');
    var originalTotalEl = bundlePicker.querySelector('[data-bundle-total-original]');
    var atcBtn = bundlePicker.querySelector('[data-bundle-atc]');
    var noticeEl = bundlePicker.querySelector('[data-bundle-notice]');
    var bundleItems = bundlePicker.querySelectorAll('[data-bundle-item]');

    function formatMoney(cents) {
      cents = Number(cents);
      if (!isFinite(cents)) cents = 0;
      var amount = (cents / 100).toFixed(2);
      var amountComma = amount.replace('.', ',');
      var amountNoDecimals = Math.round(cents / 100).toString();
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function getSelectedVariants() {
      var selected = [];
      bundleItems.forEach(function (item) {
        var autoInput = item.querySelector('[data-bundle-auto-variant]');
        if (autoInput) {
          selected.push({
            id: parseInt(autoInput.dataset.bundleAutoVariant, 10),
            price: parseInt(autoInput.dataset.bundleAutoPrice, 10)
          });
          return;
        }
        var activeBtn = item.querySelector('.bundle-size-btn.is-active');
        if (activeBtn) {
          selected.push({
            id: parseInt(activeBtn.dataset.variantId, 10),
            price: parseInt(activeBtn.dataset.variantPrice, 10)
          });
        } else {
          selected.push(null);
        }
      });
      return selected;
    }

    function updateTotal() {
      var selected = getSelectedVariants();
      var allSelected = selected.every(function (s) { return s !== null; });
      var total = 0;
      bundleItems.forEach(function (item, i) {
        var s = selected[i];
        if (s) {
          total += s.price;
        } else {
          var priceEl = item.querySelector('[data-bundle-item-price]');
          total += priceEl ? parseInt(priceEl.dataset.bundleItemPrice, 10) : 0;
        }
      });
      if (discountPercent > 0) {
        var discounted = Math.round(total * (100 - discountPercent) / 100);
        if (totalEl) totalEl.textContent = formatMoney(discounted);
        if (originalTotalEl) {
          originalTotalEl.textContent = formatMoney(total);
          originalTotalEl.style.display = '';
        }
      } else {
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (originalTotalEl) originalTotalEl.style.display = 'none';
      }
      if (atcBtn) atcBtn.disabled = !allSelected;
      if (noticeEl) noticeEl.style.display = allSelected ? 'none' : '';
    }

    function filterBundleSizeBtns(item) {
      var selections = {};
      var activeColorSwatch = item.querySelector('.bundle-swatch.is-active');
      if (activeColorSwatch) {
        var idx = parseInt(activeColorSwatch.dataset.optionIndex);
        if (!isNaN(idx)) selections[idx] = activeColorSwatch.dataset.color;
      }
      item.querySelectorAll('.bundle-option-btn.is-active').forEach(function (btn) {
        selections[parseInt(btn.dataset.optionIndex)] = btn.dataset.optionValue;
      });
      item.querySelectorAll('.bundle-size-btn').forEach(function (btn) {
        btn.classList.remove('is-active');
        var optsRaw = btn.dataset.variantOptions;
        var matches = true;
        if (optsRaw && Object.keys(selections).length > 0) {
          try {
            var opts = JSON.parse(optsRaw);
            matches = Object.keys(selections).every(function (k) {
              return opts[parseInt(k)] === selections[k];
            });
          } catch (e) { matches = true; }
        }
        btn.style.display = matches ? '' : 'none';
      });
    }

    function openBundleItem(targetItem) {
      bundleItems.forEach(function (item) {
        var isTarget = item === targetItem;
        item.classList.toggle('is-open', isTarget);
        var toggleBtn = item.querySelector('[data-bundle-toggle]');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      });
    }

    function updateBundleItemSummary(item) {
      var summaryEl = item.querySelector('[data-bundle-summary]');
      var statusEl = item.querySelector('[data-bundle-status]');
      var activeSwatch = item.querySelector('.bundle-swatch.is-active');
      var activeSizeBtn = item.querySelector('.bundle-size-btn.is-active:not(.is-disabled)');
      var autoInput = item.querySelector('[data-bundle-auto-variant]');
      var colorName = activeSwatch ? activeSwatch.dataset.color : (summaryEl ? summaryEl.dataset.defaultColor : '');
      var sizeName = activeSizeBtn ? activeSizeBtn.dataset.size : '';

      if (autoInput) {
        item.classList.add('is-complete');
        if (summaryEl) summaryEl.textContent = (colorName ? colorName + ' · ' : '') + 'W zestawie';
        if (statusEl) statusEl.textContent = 'Zmień';
      } else if (sizeName) {
        item.classList.add('is-complete');
        if (summaryEl) summaryEl.textContent = (colorName ? colorName + ' · ' : '') + 'Rozmiar ' + sizeName;
        if (statusEl) statusEl.textContent = 'Zmień';
      } else {
        item.classList.remove('is-complete');
        if (summaryEl) summaryEl.textContent = (colorName ? colorName + ' · ' : '') + 'Wybierz rozmiar';
        if (statusEl) statusEl.textContent = 'Wybierz';
      }
    }

    // Per-item: toggle & swatch click → filter size buttons
    bundleItems.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-bundle-toggle]');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          openBundleItem(isOpen ? null : item);
        });
      }

      item.querySelectorAll('.bundle-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          item.querySelectorAll('.bundle-swatch').forEach(function (s) {
            s.classList.remove('is-active');
          });
          this.classList.add('is-active');
          // Update bundle item image when color swatch is clicked
          var itemImg = item.querySelector('[data-bundle-item-img]');
          if (itemImg) {
            var newSrc = this.dataset.image || itemImg.dataset.defaultSrc;
            if (newSrc) itemImg.src = newSrc;
          }
          filterBundleSizeBtns(item);
          var sizeLabel = item.querySelector('[data-bundle-selected-size]');
          if (sizeLabel) sizeLabel.textContent = '';
          updateBundleItemSummary(item);
          updateTotal();
        });
      });

      item.querySelectorAll('.bundle-option-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var optIdx = this.dataset.optionIndex;
          item.querySelectorAll('.bundle-option-btn[data-option-index="' + optIdx + '"]').forEach(function (b) {
            b.classList.remove('is-active');
          });
          this.classList.add('is-active');
          var selectedLabel = item.querySelector('.bundle-item__option[data-option-index="' + optIdx + '"] .bundle-item__option-selected');
          if (selectedLabel) selectedLabel.textContent = this.dataset.optionValue;
          filterBundleSizeBtns(item);
          var sizeLabel = item.querySelector('[data-bundle-selected-size]');
          if (sizeLabel) sizeLabel.textContent = '';
          updateBundleItemSummary(item);
          updateTotal();
        });
      });
    });

    // Per-item: size btn click
    bundlePicker.querySelectorAll('.bundle-size-btn:not(.is-disabled)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var itemEl = this.closest('[data-bundle-item]');
        itemEl.querySelectorAll('.bundle-size-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');

        var priceEl = itemEl.querySelector('[data-bundle-item-price]');
        if (priceEl) {
          priceEl.dataset.bundleItemPrice = this.dataset.variantPrice;
          priceEl.textContent = formatMoney(parseInt(this.dataset.variantPrice, 10));
        }

        var sizeLabel = itemEl.querySelector('[data-bundle-selected-size]');
        if (sizeLabel) sizeLabel.textContent = ' ' + this.dataset.size;

        updateBundleItemSummary(itemEl);
        updateTotal();

        setTimeout(function () {
          var itemsArr = Array.prototype.slice.call(bundleItems);
          var currentIndex = itemsArr.indexOf(itemEl);
          var nextIncomplete = null;
          for (var i = 1; i <= itemsArr.length; i++) {
            var candidate = itemsArr[(currentIndex + i) % itemsArr.length];
            if (!candidate.classList.contains('is-complete')) {
              nextIncomplete = candidate;
              break;
            }
          }
          openBundleItem(nextIncomplete);
        }, 180);
      });
    });

    // Add bundle to cart via AJAX, then open cart drawer
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var selected = getSelectedVariants();
        if (!selected.every(function (s) { return s !== null; })) return;

        var atcText = atcBtn.querySelector('.bundle-atc__text');
        var originalText = atcText ? atcText.textContent : '';
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = '...';

        var bundleId = 'bundle_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
        var items = selected.map(function (s, idx) {
          var itemProps = {
            _bundle_id: bundleId,
            _bundle_slot: (idx + 1).toString()
          };
          if (discountCode) itemProps._bundle_discount = discountCode;
          if (discountPercent > 0) itemProps._bundle_discount_percent = discountPercent;
          return { id: s.id, quantity: 1, properties: itemProps };
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function () {
          if (atcText) atcText.textContent = 'Dodano ✓';
          setTimeout(function () {
            fetch('/cart.js?_=' + Date.now()).then(function (r) { return r.json(); }).then(function (cart) {
              var countEl = document.querySelector('.header__cart-count');
              if (countEl) {
                countEl.textContent = cart.item_count;
                countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
              }
              if (window.cartDrawer) window.cartDrawer.open(cart);
            });
          }, 400);
          setTimeout(function () {
            if (atcText) atcText.textContent = originalText;
            atcBtn.disabled = false;
          }, 2000);
        })
        .catch(function (err) {
          var msg = (err && err.description) ? err.description : 'Błąd dodawania do koszyka.';
          if (atcText) atcText.textContent = msg;
          setTimeout(function () {
            if (atcText) atcText.textContent = originalText;
            atcBtn.disabled = false;
            updateTotal();
          }, 3000);
        });
      });
    }

    updateTotal();
  }());

  /* --- MULTIPACK PICKER --- */
  (function () {
    var mpPicker = document.querySelector('[data-multipack-picker]');
    if (!mpPicker) return;

    var moneyFormat = mpPicker.dataset.moneyFormat || '{{ amount }}';
    var discountPercent = parseFloat(mpPicker.dataset.multipackDiscountPercent) || 0;
    var discountCode = mpPicker.dataset.multipackDiscount || '';
    var totalEl = mpPicker.querySelector('[data-multipack-total]');
    var originalTotalEl = mpPicker.querySelector('[data-multipack-total-original]');
    var atcBtn = mpPicker.querySelector('[data-multipack-atc]');
    var noticeEl = mpPicker.querySelector('[data-multipack-notice]');
    var mpItems = mpPicker.querySelectorAll('[data-multipack-item]');

    function formatMoney(cents) {
      cents = Number(cents);
      if (!isFinite(cents)) cents = 0;
      var amount = (cents / 100).toFixed(2);
      var amountComma = amount.replace('.', ',');
      var amountNoDecimals = Math.round(cents / 100).toString();
      return moneyFormat
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountComma)
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, amount);
    }

    function getSelectedVariants() {
      var selected = [];
      mpItems.forEach(function (item) {
        var autoInput = item.querySelector('[data-multipack-auto-variant]');
        if (autoInput) {
          if (autoInput.dataset.multipackAutoAvailable === 'false') {
            selected.push(null);
          } else {
            selected.push({
              id: parseInt(autoInput.dataset.multipackAutoVariant, 10),
              price: parseInt(autoInput.dataset.multipackAutoPrice, 10)
            });
          }
          return;
        }
        var activeBtn = item.querySelector('.multipack-size-btn.is-active:not(.is-disabled)');
        if (activeBtn) {
          selected.push({
            id: parseInt(activeBtn.dataset.variantId, 10),
            price: parseInt(activeBtn.dataset.variantPrice, 10)
          });
        } else {
          selected.push(null);
        }
      });
      return selected;
    }

    function updateTotal() {
      var selected = getSelectedVariants();
      var allSelected = selected.every(function (s) { return s !== null; });
      var total = 0;
      mpItems.forEach(function (item, i) {
        var s = selected[i];
        if (s) {
          total += s.price;
        } else {
          var priceEl = item.querySelector('[data-multipack-item-price]');
          total += priceEl ? parseInt(priceEl.dataset.multipackItemPrice, 10) : 0;
        }
      });
      if (discountPercent > 0) {
        var discounted = Math.round(total * (100 - discountPercent) / 100);
        if (totalEl) totalEl.textContent = formatMoney(discounted);
        if (originalTotalEl) {
          originalTotalEl.textContent = formatMoney(total);
          originalTotalEl.style.display = '';
        }
      } else {
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (originalTotalEl) originalTotalEl.style.display = 'none';
      }
      if (atcBtn) atcBtn.disabled = !allSelected;
      if (noticeEl) noticeEl.style.display = allSelected ? 'none' : '';
    }

    function filterMpSizeBtns(item) {
      var selections = {};
      var activeColorSwatch = item.querySelector('.multipack-swatch.is-active');
      if (activeColorSwatch) {
        var idx = parseInt(activeColorSwatch.dataset.optionIndex);
        if (!isNaN(idx)) selections[idx] = activeColorSwatch.dataset.color;
      }
      item.querySelectorAll('.multipack-size-btn').forEach(function (btn) {
        btn.classList.remove('is-active');
        var optsRaw = btn.dataset.variantOptions;
        var matches = true;
        if (optsRaw && Object.keys(selections).length > 0) {
          try {
            var opts = JSON.parse(optsRaw);
            matches = Object.keys(selections).every(function (k) {
              return opts[parseInt(k)] === selections[k];
            });
          } catch (e) { matches = true; }
        }
        btn.style.display = matches ? '' : 'none';
      });
    }

    function openMpItem(targetItem) {
      mpItems.forEach(function (item) {
        var isTarget = item === targetItem;
        item.classList.toggle('is-open', isTarget);
        var toggleBtn = item.querySelector('[data-multipack-toggle]');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', isTarget ? 'true' : 'false');
      });
    }

    function updateMpItemSummary(item) {
      var summaryEl = item.querySelector('[data-multipack-summary]');
      var statusEl = item.querySelector('[data-multipack-status]');
      var activeSwatch = item.querySelector('.multipack-swatch.is-active');
      var activeSizeBtn = item.querySelector('.multipack-size-btn.is-active:not(.is-disabled)');
      var colorName = activeSwatch ? activeSwatch.dataset.color : (summaryEl ? summaryEl.dataset.defaultColor : '');
      var sizeName = activeSizeBtn ? activeSizeBtn.dataset.size : '';

      if (sizeName) {
        item.classList.add('is-complete');
        if (summaryEl) summaryEl.textContent = (colorName ? colorName + ' · ' : '') + 'Rozmiar ' + sizeName;
        if (statusEl) statusEl.textContent = 'Zmień';
      } else {
        item.classList.remove('is-complete');
        if (summaryEl) summaryEl.textContent = (colorName ? colorName + ' · ' : '') + 'Wybierz rozmiar';
        if (statusEl) statusEl.textContent = 'Wybierz';
      }
    }

    mpItems.forEach(function (item) {
      var toggleBtn = item.querySelector('[data-multipack-toggle]');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          openMpItem(isOpen ? null : item);
        });
      }

      item.querySelectorAll('.multipack-swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          item.querySelectorAll('.multipack-swatch').forEach(function (s) {
            s.classList.remove('is-active');
          });
          this.classList.add('is-active');
          var itemImg = item.querySelector('[data-multipack-item-img]');
          if (itemImg) {
            var newSrc = this.dataset.image || itemImg.dataset.defaultSrc;
            if (newSrc) itemImg.src = newSrc;
          }
          filterMpSizeBtns(item);
          var sizeLabel = item.querySelector('[data-multipack-selected-size]');
          if (sizeLabel) sizeLabel.textContent = '';
          updateMpItemSummary(item);
          updateTotal();
        });
      });
    });

    mpPicker.querySelectorAll('.multipack-size-btn:not(.is-disabled)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var itemEl = this.closest('[data-multipack-item]');
        itemEl.querySelectorAll('.multipack-size-btn').forEach(function (b) {
          b.classList.remove('is-active');
        });
        this.classList.add('is-active');

        var priceEl = itemEl.querySelector('[data-multipack-item-price]');
        if (priceEl) {
          priceEl.dataset.multipackItemPrice = this.dataset.variantPrice;
          priceEl.textContent = formatMoney(parseInt(this.dataset.variantPrice, 10));
        }

        var sizeLabel = itemEl.querySelector('[data-multipack-selected-size]');
        if (sizeLabel) sizeLabel.textContent = ' ' + this.dataset.size;

        updateMpItemSummary(itemEl);
        updateTotal();

        setTimeout(function () {
          var itemsArr = Array.prototype.slice.call(mpItems);
          var currentIndex = itemsArr.indexOf(itemEl);
          var nextIncomplete = null;
          for (var i = 1; i <= itemsArr.length; i++) {
            var candidate = itemsArr[(currentIndex + i) % itemsArr.length];
            if (!candidate.classList.contains('is-complete')) {
              nextIncomplete = candidate;
              break;
            }
          }
          openMpItem(nextIncomplete);
        }, 180);
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        var selected = getSelectedVariants();
        if (!selected.every(function (s) { return s !== null; })) return;

        var atcText = atcBtn.querySelector('.multipack-atc__text');
        var originalText = atcText ? atcText.textContent : '';
        atcBtn.disabled = true;
        if (atcText) atcText.textContent = '...';

        addMultipackToCart();
        function addMultipackToCart() {
          var packId = 'pack_' + Date.now() + '_' + Math.random().toString(36).slice(2, 7);
          var items = selected.map(function (s, idx) {
            var itemProps = {
              _bundle_id: packId,
              _pack_slot: (idx + 1).toString()
            };
            if (discountCode) itemProps._multipack_discount = discountCode;
            if (discountPercent > 0) itemProps._multipack_discount_percent = discountPercent;
            return { id: s.id, quantity: 1, properties: itemProps };
          });

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (r) {
            if (!r.ok) return r.json().then(function (e) { throw e; });
            return r.json();
          })
          .then(function () {
            return fetch('/cart.js?_=' + Date.now()).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            var addedPackItems = cart.items.filter(function (i) {
              return i.properties && i.properties._bundle_id === packId;
            });
            var totalAddedQty = addedPackItems.reduce(function (sum, i) {
              return sum + i.quantity;
            }, 0);
            var totalExpectedQty = items.reduce(function (sum, i) {
              return sum + i.quantity;
            }, 0);

            if (totalAddedQty < totalExpectedQty) {
              var updates = {};
              addedPackItems.forEach(function (i) { updates[i.key] = 0; });
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              })
              .then(function (r) { return r.json(); })
              .then(function () {
                throw { description: 'Nie wszystkie produkty z zestawu są dostępne.' };
              });
            }
            if (atcText) atcText.textContent = 'Dodano ✓';
            var countEl = document.querySelector('.header__cart-count');
            if (countEl) {
              countEl.textContent = cart.item_count;
              countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
            }
            if (window.cartDrawer) window.cartDrawer.open(cart);
            setTimeout(function () {
              if (atcText) atcText.textContent = originalText;
              atcBtn.disabled = false;
            }, 2000);
          })
          .catch(function (err) {
            var msg = (err && err.description) ? err.description : 'Błąd dodawania do koszyka.';
            if (atcText) atcText.textContent = msg;
            setTimeout(function () {
              if (atcText) atcText.textContent = originalText;
              atcBtn.disabled = false;
              updateTotal();
            }, 3000);
          });
        }
      });
    }

    updateTotal();
  }());

});

// Size guide modal
function initSizeGuideModal() {
  var buttons = document.querySelectorAll('[data-size-guide-img]');
  if (!buttons.length) return;

  var modal = document.querySelector('.size-guide-modal');
  function closeSizeGuideModal() {
    if (modal) modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (!modal) {
    modal = document.createElement('div');
    modal.className = 'size-guide-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="size-guide-modal__inner">' +
        '<button type="button" class="size-guide-modal__close" aria-label="Zamknij">&times;</button>' +
        '<img class="size-guide-modal__img" src="" alt="Size guide">' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelector('.size-guide-modal__close').addEventListener('click', closeSizeGuideModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeSizeGuideModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeSizeGuideModal();
    });
  }

  var modalImg = modal.querySelector('.size-guide-modal__img');

  function openSizeGuideModal(imgSrc) {
    modalImg.src = imgSrc;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  buttons.forEach(function (btn) {
    if (btn.dataset.sizeGuideBound) return;
    btn.dataset.sizeGuideBound = 'true';
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-size-guide-img');
      if (src) openSizeGuideModal(src);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSizeGuideModal);
} else {
  initSizeGuideModal();
}

// Product page image lightbox
function initProductLightbox() {
  var gallery = document.querySelector('[data-lightbox-gallery]');
  if (!gallery) return;

  var images = [];
  try {
    images = JSON.parse(gallery.getAttribute('data-lightbox-images') || '[]');
  } catch (e) { return; }
  if (!images.length) return;

  var lb = document.querySelector('.product-lightbox');
  var lbImg, lbCounter;
  var currentIndex = 0;

  function showLightbox(index) {
    if (!images.length) return;
    currentIndex = ((index % images.length) + images.length) % images.length;
    lbImg.src = images[currentIndex];
    lbCounter.textContent = (currentIndex + 1) + ' / ' + images.length;
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lb.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (!lb) {
    lb = document.createElement('div');
    lb.className = 'product-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<button type="button" class="product-lightbox__close" aria-label="Zamknij">&times;</button>' +
      '<button type="button" class="product-lightbox__nav product-lightbox__nav--prev" aria-label="Poprzednie">&#8249;</button>' +
      '<img class="product-lightbox__img" src="" alt="">' +
      '<button type="button" class="product-lightbox__nav product-lightbox__nav--next" aria-label="Następne">&#8250;</button>' +
      '<span class="product-lightbox__counter"></span>';
    document.body.appendChild(lb);

    lb.querySelector('.product-lightbox__close').addEventListener('click', closeLightbox);
    lb.querySelector('.product-lightbox__nav--prev').addEventListener('click', function () { showLightbox(currentIndex - 1); });
    lb.querySelector('.product-lightbox__nav--next').addEventListener('click', function () { showLightbox(currentIndex + 1); });

    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightbox(currentIndex - 1);
      if (e.key === 'ArrowRight') showLightbox(currentIndex + 1);
    });
  }

  lbImg = lb.querySelector('.product-lightbox__img');
  lbCounter = lb.querySelector('.product-lightbox__counter');

  // Grid image buttons
  gallery.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
    if (btn.dataset.lightboxBound) return;
    btn.dataset.lightboxBound = 'true';
    btn.addEventListener('click', function () {
      showLightbox(parseInt(btn.getAttribute('data-lightbox-open'), 10));
    });
  });

  // Main image
  var mainImg = document.querySelector('[data-lightbox-main]');
  if (mainImg && !mainImg.dataset.lightboxBound) {
    mainImg.dataset.lightboxBound = 'true';
    mainImg.addEventListener('click', function () { showLightbox(0); });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductLightbox);
} else {
  initProductLightbox();
}

// Global Shopify Theme Editor lifecycle integration
document.addEventListener('shopify:section:load', function (e) {
  var container = e.target || document;
  if (typeof initGenericCarousels === 'function') initGenericCarousels(container);
  if (typeof initNaMarquees === 'function') initNaMarquees(container);
  if (typeof initProductVariants === 'function') initProductVariants(container);
  if (typeof initFitGuideCarousels === 'function') initFitGuideCarousels(container);
  if (typeof initSizeGuideModal === 'function') initSizeGuideModal();
  if (typeof initProductLightbox === 'function') initProductLightbox();
});
